import { Controller } from '@hotwired/stimulus';

let sequence = 0;

export default class extends Controller {
  static values = { id: String, text: String, withIndex: Boolean, maxItems: Number };

  connect() {
    if (this.hasMaxItemsValue) {
      this.refreshAddButtons(document.getElementById(this.idValue));
    }
  }

  add(event) {
    const box = document.getElementById(this.idValue);
    const currentIndex = box.childElementCount;

    if (this.hasMaxItemsValue && currentIndex >= this.maxItemsValue) {
      this.refreshAddButtons(box);
      return;
    }

    box.insertAdjacentHTML(
      'beforeend',
      event.currentTarget.dataset.fields.replace(/new_field/g, `${new Date().getTime()}${(sequence += 1)}`)
    );

    if (this.withIndexValue) {
      const childIndex = document.getElementsByClassName('child-index');
      const lastChild = childIndex[childIndex.length - 1];

      lastChild.innerHTML = currentIndex + 1;
    }

    this.refreshAddButtons(box);
  }

  destroy(event) {
    if (confirm(this.textValue)) {
      const dynamicFields = event.currentTarget.closest('.dynamic-fields');
      const box = dynamicFields.parentElement;

      dynamicFields.remove();
      this.refreshAddButtons(box);
    }
  }

  refreshAddButtons(box) {
    if (!box || !box.id) {
      return;
    }

    document
      .querySelectorAll(`[data-new-fields-id-value="${box.id}"][data-new-fields-max-items-value]`)
      .forEach((button) => {
        button.disabled = box.childElementCount >= Number(button.dataset.newFieldsMaxItemsValue);
      });
  }
}
